import { apiFetch } from './http';

export const registerPushToken = (payload) => {
  if (!payload?.token) {
    return Promise.reject(new Error('Token de push requerido'));
  }
  return apiFetch('/api/push/register', {
    method: 'POST',
    body: payload
  });
};

export const unregisterPushToken = (token) => {
  if (!token) {
    return Promise.resolve(null);
  }
  return apiFetch(`/api/push/register/${encodeURIComponent(token)}`, {
    method: 'DELETE'
  });
};
